export enum Unit {
  VIEWPORT_HEIGHT = "vh",
  PIXEL = "px",
  PERCENTAGE = "%",
}

export enum Text {
  EMBEDDED_PREVIEW_GIF_STYLE_HEADER = "Determines whether your gifs will play at the same time or only on hover.",
}